import { render, staticRenderFns } from "./EpubViewer.vue?vue&type=template&id=62c0508d&scoped=true&"
import script from "./EpubViewer.vue?vue&type=script&lang=js&"
export * from "./EpubViewer.vue?vue&type=script&lang=js&"
import style0 from "./EpubViewer.vue?vue&type=style&index=0&id=62c0508d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c0508d",
  null
  
)

export default component.exports